import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { santaClaritaConfig } from "./data";

export default function SantaClaritaPage() {
  return <CityPageTemplate config={santaClaritaConfig} />;
}